import React, { Component, Fragment } from 'react';
import withStyles from '@mui/styles/withStyles';
import ColumnLayout from '../../components/layout/ColumnLayout';
import PlaqueOrder from '../../fragments/PlaqueOrder';
import { getUser } from '../../utils/sessions';
import CommunicationNoteModal from '../CommunicationNotes/CommunicationNoteModal';
import Grid from '../../components/layout/Grid';
import Button from '../../components/form/Button';
import Table, { Cell, HeaderRow, Row } from '../../components/table/Table';
import { niceDateTimeFromString } from '../../utils/date';
import { joinDefined, PAGE_ENQUIRIES } from '../../utils/strings';
import { EnquiriesIcon, TickIcon } from '../../components/IconIndex';
import SendProofModal from './Modals/SendProofModal';
import EditProofModal from './Modals/EditProofModal';
import { getOffice } from '../../environment';
import AppointmentModal from '../../components/modal/AppointmentModal';
import gql from 'graphql-tag';
import Appointment from '../../fragments/Appointment';
import { Query } from '../../reactApolloCompat';
import Spinner from '../../components/loading/Spinner';
import AlertBar from '../../components/form/AlertBar';
import { appointmentColumns } from '../../utils/appointments';

class CorrespondenceTab extends Component {

    state = {
        showSendProofModal: false,
        proofEmailEditModal: {
            open: false,
            proofEmailId: null
        },
        showAppointmentModal: false, 
        appointmentId: null 
    };

    onClickViewAppointment(id) {
        this.setState({ showAppointmentModal: true, appointmentId: id });
    }

    render() {
        const { showSendProofModal, proofEmailEditModal } = this.state;
        const { form } = this.props;
        const user = getUser();
        const office = getOffice();
        return (
            <Fragment>
                <SendProofModal
                    open={showSendProofModal}
                    plaqueOrderID={form.getField('ID')}
                    plaqueOrderClient={form.state.Client}
                    onClose={() => this.handleCloseSendProofModal()}
                    parentForm={form}
                    substitutionFields={{
                        '[[Client.FirstName]]': form.getField('Client.FirstName'),
                        '[[Client.Surname]]': form.getField('Client.Surname'),
                        '[[Deceased.FirstName]]': form.getField('Deceased.FirstName'),
                        '[[Deceased.Surname]]': form.getField('Deceased.Surname'),
                        '[[Reference]]': form.getField('LegacyKey'),
                        '[[StaffName]]': user.FirstName + ' ' + user.Surname,
                        '[[OfficeName]]': office && office.Title,
                        '[[OfficePhone]]': office && office.Phone
                    }}
                />

                <EditProofModal
                    open={!!proofEmailEditModal.open}
                    plaqueOrderID={form.getField('ID')}
                    plaqueOrderClient={form.state.Client}
                    plaqueOrderProofEmails={form.state.ProofEmails}
                    emailId={proofEmailEditModal.proofEmailId}
                    onClose={() => this.handleCloseEditProofModal()}
                    parentForm={form}
                    substitutionFields={{
                        '[[Client.FirstName]]': form.getField('Client.FirstName'),
                        '[[Client.Surname]]': form.getField('Client.Surname'),
                        '[[Deceased.FirstName]]': form.getField('Deceased.FirstName'),
                        '[[Deceased.Surname]]': form.getField('Deceased.Surname'),
                        '[[Reference]]': form.getField('LegacyKey'),
                        '[[StaffName]]': user.FirstName + ' ' + user.Surname,
                        '[[OfficeName]]': office && office.Title,
                        '[[OfficePhone]]': office && office.Phone
                    }}
                />
                <ColumnLayout>
                    {this.renderLeftColumn()}
                    {this.renderRightColumn()}
                </ColumnLayout>
            </Fragment>
        );
    }

    renderLeftColumn() {
        return (
            <Grid container>
                <Grid item>
                    {this.renderCommunicationNotes()}
                </Grid>

                <Grid item>
                    {this.renderAppointments()}
                </Grid>

                <Grid item>
                    {this.renderRelatedRecords()}
                </Grid>
            </Grid>
        );
    }

    renderRightColumn() {
        return <Fragment>{this.renderEmailProofToClient()}</Fragment>;
    }

    readAppointments() {
        return gql`
            ${Appointment}
            query readAppointments($plaqueID: ID){
                readAppointments(plaqueID: $plaqueID){
                    edges {
                        node {
                            ...Appointment
                        }
                    }
                }
            }
        `
    }

    renderAppointments() {
        const { form } = this.props;
        const { showAppointmentModal, appointmentId } = this.state;
        const enquiryID = Number(form.getField('ID'));

        return (
            <Grid container bucket>
                <Grid item>
                    <h4>Appointments</h4>
                </Grid>

                <AppointmentModal
                    open={!!showAppointmentModal}
                    parentForm={form}
                    appointmentId={appointmentId || null}
                    onClose={() => this.setState({ showAppointmentModal: false, appointmentId: null })}
                />

                <Grid item>
                    {!!enquiryID && 
                        <Query
                            query={this.readAppointments()}
                            variables={{ plaqueID: enquiryID }}
                            fetchPolicy="cache-and-network"
                            notifyOnNetworkStatusChange
                        >
                            {({ loading, data, error, refetch, networkStatus }) => {

                                if (!!loading && (!data || networkStatus === 1))
                                    return (
                                        <Grid item>
                                            <Spinner /> Loading appointments...
                                        </Grid>
                                    );
                                if (!!error)
                                    return (
                                        <Grid item>
                                            <AlertBar variant="error">Error loading appointments.</AlertBar>
                                        </Grid>
                                    );

                                const items = (data && data.readAppointments && data.readAppointments.edges.map(e => e.node)) || [];
                            
                                return items && items.length > 0 ? (
                                    <Table>
                                        <HeaderRow pad>
                                            {appointmentColumns.map(column => (
                                                <Cell key={column.label}>{column.label}</Cell>
                                            ))}
                                        </HeaderRow>
                                        {items && items.length > 0 && items.map((row, idx) => {
                                            return (
                                                <Row pad key={row.ID}>
                                                    {appointmentColumns.map(column => {
                                                        return (
                                                            <Cell
                                                                key={column.label}
                                                                dataLabel={column.label}
                                                            >
                                                                {column.renderCell(row, this, idx)}
                                                            </Cell>
                                                        );
                                                    })}
                                                </Row>
                                            )
                                        })}
                                    </Table>
                                ) : <p>There are currently no appointments.</p>
                            }}
                        </Query>
                    }
                </Grid>
            </Grid>
        ) 
    }

    renderRelatedRecords() {
        const { form, context } = this.props;
        const hasRelatedEnquiry = !!form.getField('Enquiry.ID');
        const enquiryLegacyKey = hasRelatedEnquiry ? form.getField('Enquiry.LegacyKey') : null;
        const enquiryType = hasRelatedEnquiry ? form.getField('Enquiry.EnquiryType') : null;
        const enquiryID = hasRelatedEnquiry ? form.getField('Enquiry.ID') : null;
        const relatedRecordListLink = enquiryType ?  PAGE_ENQUIRIES : null; 
        
        return (
            <Grid container bucket>
                <Grid item>
                    <h4>Related Records</h4>
                </Grid>

                {hasRelatedEnquiry && enquiryLegacyKey && relatedRecordListLink && enquiryID ? (
                    <Grid item>
                        <Button
                            icon={<EnquiriesIcon />}
                            variant="urgent"
                            onClick={() => context.props.history.push(relatedRecordListLink + enquiryID)}
                        >
                            View Booking{' '}{enquiryLegacyKey}
                        </Button>
                    </Grid>
                ) : (<Grid item><p>There is no related booking record.</p></Grid>)}
            </Grid>
        );
    }

    renderCommunicationNotes() {
        const { form } = this.props;
        const user = getUser();
        const office = getOffice();
        return <CommunicationNoteModal
            recordID={form.getField('ID')}
            recordKey={form.getField('LegacyKey')}
            recordType="PlaqueOrder"
            substitutionFields={{
                '[[Client.FirstName]]': form.getField('Client.FirstName'),
                '[[Client.Surname]]': form.getField('Client.Surname'),
                '[[Deceased.FirstName]]': form.getField('Deceased.FirstName'),
                '[[Deceased.Surname]]': form.getField('Deceased.Surname'),
                '[[Reference]]': form.getField('LegacyKey'),
                '[[StaffName]]': user.FirstName + ' ' + user.Surname,
                '[[OfficeName]]': office && office.Title,
                '[[OfficePhone]]': office && office.Phone
            }}
        />;
    }

    renderEmailProofToClient() {
        return (
            <Grid container bucket>
                {this.renderProofEmailsHistory()}
                <Grid item>
                    <Button variant="primary" onClick={() => this.handleShowSendProofModal()}>
                        Send Proof Email...
                    </Button>
                </Grid>
            </Grid>
        );
    }

    renderProofEmailsHistory() {
        const { form } = this.props;
        let proofEmails = form.getField('ProofEmails');
        const applicant = form.getField('Client');

        proofEmails = proofEmails.filter(obj => !obj.EmailSupplier);

        return (
            <Fragment>
                <Grid item>
                    <h4>Proof Emails</h4>
                </Grid>
                <Grid item>
                    {(proofEmails && proofEmails.length > 0) ? <Table>
                        <HeaderRow pad>
                            <Cell colSpan={1}>ID</Cell>
                            <Cell colSpan={1}>Sent</Cell>
                            <Cell colSpan={1}>Send To</Cell>
                            <Cell colSpan={1}>Approved</Cell>
                        </HeaderRow>
                        {proofEmails.map(proofEmail => (
                            <Row pad key={'email-' + proofEmail.ID}>
                                <Cell dataLabel="Email No.">
                                    <Button
                                        variant="link-orange"
                                        onClick={() => this.handleShowEditProofModal(proofEmail.ID)}
                                    >
                                        #{proofEmail.ID}
                                    </Button>
                                </Cell>
                                <Cell
                                    dataLabel="Sent">{niceDateTimeFromString(proofEmail.EmailSent) || 'Not sent'}</Cell>
                                <Cell dataLabel="Send to">
                                    {joinDefined(
                                        [
                                            proofEmail.EmailApplicant && !!applicant ? applicant.Email : null,
                                            proofEmail.EmailOther ? proofEmail.OtherEmailAddress : null
                                        ],
                                        ', '
                                    )}
                                </Cell>
                                <Cell dataLabel="Approved">
                                    {!!proofEmail.Approved && <TickIcon />}
                                </Cell>
                            </Row>
                        ))}
                    </Table> : <p>There are currently no proof emails.</p>
                    }
                </Grid>
            </Fragment>
        );
    }

    handleShowSendProofModal() {
        this.setState({ showSendProofModal: true });
    }

    handleCloseSendProofModal() {
        this.setState({ showSendProofModal: false });
    }

    handleShowEditProofModal(id) {
        this.setState({
            proofEmailEditModal: {
                open: true,
                proofEmailId: id
            }
        });
    }


    handleCloseEditProofModal() {
        this.setState({
            proofEmailEditModal: {
                open: false,
                proofEmail: null
            }
        });
    }

}

export default {
    id: 'Correspondence',
    label: 'Correspondence',
    component: withStyles({})(CorrespondenceTab),
    fragment: PlaqueOrder
};
